import { render, staticRenderFns } from "./FileView.vue?vue&type=template&id=dc43c186&scoped=true"
import script from "./FileView.vue?vue&type=script&lang=js"
export * from "./FileView.vue?vue&type=script&lang=js"
import style0 from "./FileView.vue?vue&type=style&index=0&id=dc43c186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc43c186",
  null
  
)

export default component.exports